module.exports = new __parcel__URL__("Employee Handbook.b58ecb32.svg").toString();